//# sourceMappingURL=public-interfaces.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-table/src/browser/public-interfaces.js
// module id = 2156
// module chunks = 2